'use client';

import { c as _c } from "react/compiler-runtime";
import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { Backdrop } from '@libs/shared-ui';
import type { PrimaryNavigationItem } from '../../../types';
import { DropdownPanel } from './dropdown-panel';
import { NavigationItem } from './navigation-item';
import { useDesktopMenu } from './use-desktop-menu';
import './desktop-menu.scss';
const MENU_OPEN_DELAY_MS = 100;
type DesktopMenuProps = {
  items: PrimaryNavigationItem[];
};
export function DesktopMenu(t0) {
  const $ = _c(17);
  const {
    items
  } = t0;
  const {
    closeMenu,
    openMenu,
    portalContainer,
    setNavigationRoot,
    setOpenMenu
  } = useDesktopMenu();
  let t1;
  if ($[0] !== setNavigationRoot) {
    t1 = <nav ref={setNavigationRoot} className="desktop-menu" />;
    $[0] = setNavigationRoot;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== closeMenu || $[3] !== items) {
    let t3;
    if ($[5] !== closeMenu) {
      t3 = item => <NavigationItem key={item.id} item={item} onKeyboardClose={closeMenu}>{item.kind !== "link" && <NavigationMenu.Content className="desktop-menu__content"><DropdownPanel item={item} /></NavigationMenu.Content>}</NavigationItem>;
      $[5] = closeMenu;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[2] = closeMenu;
    $[3] = items;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <NavigationMenu.List className="desktop-menu__list">{t2}</NavigationMenu.List>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== portalContainer) {
    t4 = portalContainer && <NavigationMenu.Portal container={portalContainer}><NavigationMenu.Positioner align="start" collisionPadding={0} positionMethod="absolute" sideOffset={16} className="desktop-menu__positioner"><NavigationMenu.Backdrop render={<Backdrop className="desktop-menu__backdrop" />} /><NavigationMenu.Popup className="desktop-menu__popup"><NavigationMenu.Viewport className="desktop-menu__viewport" /></NavigationMenu.Popup></NavigationMenu.Positioner></NavigationMenu.Portal>;
    $[9] = portalContainer;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== openMenu || $[12] !== setOpenMenu || $[13] !== t1 || $[14] !== t3 || $[15] !== t4) {
    t5 = <NavigationMenu.Root delay={MENU_OPEN_DELAY_MS} value={openMenu} onValueChange={setOpenMenu} render={t1}>{t3}{t4}</NavigationMenu.Root>;
    $[11] = openMenu;
    $[12] = setOpenMenu;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}